import Vue from 'vue'
import store from './store'

import { convertIntObj } from '@/assets/scripts/utils.js'

import Favorite from '@/components/Favorite.vue'
// import CountItems from '@/components/CountItems.vue'
import Navigation from '@/components/Navigation.vue'

Vue.config.productionTip = false
store.dispatch('loadFavorites');

window.selfcareConfig.eventListIsLoaded = document.createEvent('Event');
window.selfcareConfig.eventListIsLoaded.initEvent('eventListIsLoaded', true, true);
document.addEventListener('eventListIsLoaded', function() {

  for (let i of [
      ['.menu-shop', Navigation],
      ['.add-to-favorites', Favorite],
  ]) {
      for (let el of document.querySelectorAll(i[0])) {
          const propsData = el.tagName == 'SCRIPT' ? JSON.parse(el.textContent) : convertIntObj(el.dataset)
          new Vue({
              store,
              render: h => h(i[1], { props: { ...propsData } })
          }).$mount(el);
      }
  }

});
document.dispatchEvent(window.selfcareConfig.eventListIsLoaded);
